import { createFileRoute } from '@tanstack/react-router';

// `/comms/drafts` — the review/approve queue (Agent U3, spec 07 §4).
// `?draft=<id>` deep-links a specific draft (e.g. from a Needs-You mention /
// the Telegram mirror). Optional + validated to undefined otherwise, so an
// unrelated visit is byte-identical. The whole Comm Center area mounts only
// behind env.VITE_COMM_CENTER via the parent `/comms` route (Agent U1).
interface DraftsSearch {
  draft?: string;
}

export const Route = createFileRoute('/_authenticated/comms/drafts')({
  validateSearch: (search: Record<string, unknown>): DraftsSearch => ({
    draft: typeof search.draft === 'string' ? search.draft : undefined,
  }),
});
